const DB_NAME = "GimsDB";
const DB_VERSION = 1;

const STORES = ["boatRegistration", "statements", "applicationTraining"];

const openDatabase = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = function (event) {
      const db = event.target.result;

      STORES.forEach((store) => {
        if (!db.objectStoreNames.contains(store)) {
          db.createObjectStore(store, { keyPath: "id", autoIncrement: true });
          console.log(`✅ Создано хранилище: ${store}`);
        }
      });
    };

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onerror = function () {
      reject(request.error);
    };
  });
};

export const saveDataToIndexedDB = async (storeName, data) => {
  try {
    const db = await openDatabase();
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    const requestData = {
      id: 1,
      timestamp: Date.now(),
      data,
    };

    return new Promise((resolve, reject) => {
      const getRequest = store.get(1);

      getRequest.onsuccess = () => {
        if (getRequest.result) {
          store.put(requestData).onsuccess = () => {
            // console.log(
            //   `✅ Данные обновлены в IndexedDB (store: ${storeName})`,
            //   requestData,
            // );
            resolve();
          };
        } else {
          store.add(requestData).onsuccess = () => {
            // console.log(
            //   `✅ Данные сохранены в IndexedDB (store: ${storeName})`,
            //   requestData,
            // );
            resolve();
          };
        }
      };

      getRequest.onerror = () => reject(getRequest.error);
    });
  } catch (error) {
    console.error(
      `❌ Ошибка при сохранении данных в IndexedDB (${storeName}):`,
      error,
    );
  }
};

export const getDataFromIndexedDB = async (storeName) => {
  try {
    const db = await openDatabase(storeName);
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);
    const getAllRequest = store.getAll();

    return new Promise((resolve, reject) => {
      getAllRequest.onsuccess = () => resolve(getAllRequest.result);
      getAllRequest.onerror = () => reject(getAllRequest.error);
    });
  } catch (error) {
    console.error(
      `Ошибка при получении данных из IndexedDB (${storeName}):`,
      error,
    );
  }
};

export const deleteDataFromIndexedDB = async (storeName, id) => {
  try {
    const db = await openDatabase(storeName);
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    store.delete(id);

    return new Promise((resolve) => {
      transaction.oncomplete = () => {
        // console.log(`Данные с ID ${id} удалены из IndexedDB (${storeName})`);
        resolve();
      };
    });
  } catch (error) {
    console.error(
      `Ошибка при удалении данных из IndexedDB (${storeName}):`,
      error,
    );
  }
};

export const logIndexedDBData = async (storeName) => {
  // console.log(`📂 Данные из IndexedDB (store: ${storeName}):`, storedData);
  return await getDataFromIndexedDB(storeName);
};
